import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDashboardRouteByRole } from '../../utils/navigationUtils';

const RoleSelect = () => {
  const { roles, setActiveRole, userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (role) => {
    setActiveRole(role);
    const fromPath = location.state?.from || '';

    // If we have an intended deep link, try to route to the application's page for this role
    // Expected application routes contain an applicationId at the end
    const appIdMatch = /\/(application-review|application|details|review)\/(.*)$/i.exec(fromPath);
    const applicationId = appIdMatch ? appIdMatch[2] : null;

    if (applicationId) {
      // Map role to correct application route
      let dest = '';
      switch (role) {
        case 'Hospital':
          dest = `/hospital/application/${applicationId}`;
          break;
        case 'Doctor':
          dest = `/doctor/application-review/${applicationId}`;
          break;
        case 'PolicyWriter':
          dest = `/policy/details/${applicationId}`;
          break;
        case 'FinancialTeam':
          dest = `/dashboard/financial/review/${applicationId}`;
          break;
        case 'SuperAdmin':
        case 'SystemAdmin':
          dest = `/admin/hospital-details/${applicationId}`;
          break;
        default:
          dest = '';
      }

      if (dest) {
        navigate(dest, { replace: true });
        return;
      }
    }

    // Fallback to dashboard
    const route = getDashboardRouteByRole(role);
    const hasFrom = Boolean(fromPath);
    if (hasFrom) navigate(route, { replace: true });
    else navigate(route);
  };

  // Fallback: if no roles, go home
  if (!roles || roles.length === 0) {
    navigate('/', { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md border">
        <h1 className="text-2xl font-bold mb-2 text-gray-800">Select a role</h1>
        <p className="text-sm text-gray-600 mb-6">Welcome {userData?.profile?.name || userData?.email}. Choose how you'd like to continue.</p>
        <div className="space-y-3">
          {roles.map((r) => (
            <button key={r} onClick={() => handleSelect(r)} className="w-full px-4 py-3 rounded-lg border hover:bg-teal-50 text-left">
              <span className="font-medium text-gray-800">{r}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoleSelect;
